/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  FlightCheckoutError,
  FlightExchangeAuthenticationRefreshRequest,
  FlightExchangeAuthenticationRequest,
  FlightExchangeAuthenticationResponse,
  FlightExchangeConfirmationRequest,
  FlightExchangeConfirmationResponse,
  FlightExchangeConsentRequest,
  FlightExchangePreparationRequest,
  FlightExchangePreparationResponse,
  FlightExchangeReviewResponse,
} from "../models/index";
import {
  FlightCheckoutErrorFromJSON,
  FlightCheckoutErrorToJSON,
  FlightExchangeAuthenticationRefreshRequestFromJSON,
  FlightExchangeAuthenticationRefreshRequestToJSON,
  FlightExchangeAuthenticationRequestFromJSON,
  FlightExchangeAuthenticationRequestToJSON,
  FlightExchangeAuthenticationResponseFromJSON,
  FlightExchangeAuthenticationResponseToJSON,
  FlightExchangeConfirmationRequestFromJSON,
  FlightExchangeConfirmationRequestToJSON,
  FlightExchangeConfirmationResponseFromJSON,
  FlightExchangeConfirmationResponseToJSON,
  FlightExchangeConsentRequestFromJSON,
  FlightExchangeConsentRequestToJSON,
  FlightExchangePreparationRequestFromJSON,
  FlightExchangePreparationRequestToJSON,
  FlightExchangePreparationResponseFromJSON,
  FlightExchangePreparationResponseToJSON,
  FlightExchangeReviewResponseFromJSON,
  FlightExchangeReviewResponseToJSON,
} from "../models/index";

export interface FlightExchangeAuthenticationCreateRequest {
  bookingId: string;
  exchangeId: string;
  flightExchangeAuthenticationRequest: FlightExchangeAuthenticationRequest;
  test?: boolean;
}

export interface FlightExchangeAuthenticationGetRequest {
  bookingId: string;
  exchangeId: string;
  test?: boolean;
}

export interface FlightExchangeAuthenticationRefreshOperationRequest {
  bookingId: string;
  exchangeId: string;
  flightExchangeAuthenticationRefreshRequest: FlightExchangeAuthenticationRefreshRequest;
  test?: boolean;
}

export interface FlightExchangeConfirmationCreateRequest {
  bookingId: string;
  exchangeId: string;
  flightExchangeConfirmationRequest: FlightExchangeConfirmationRequest;
  test?: boolean;
}

export interface FlightExchangeConfirmationGetRequest {
  bookingId: string;
  exchangeId: string;
  test?: boolean;
}

export interface FlightExchangeConfirmationRecoverRequest {
  bookingId: string;
  exchangeId: string;
  test?: boolean;
}

export interface FlightExchangeConsentCreateRequest {
  bookingId: string;
  exchangeId: string;
  flightExchangeConsentRequest: FlightExchangeConsentRequest;
  test?: boolean;
}

export interface FlightExchangePreparationCreateRequest {
  bookingId: string;
  flightExchangePreparationRequest: FlightExchangePreparationRequest;
  test?: boolean;
}

export interface FlightExchangePreparationGetRequest {
  bookingId: string;
  exchangeId: string;
  test?: boolean;
}

export interface FlightExchangePreparationLatestGetRequest {
  bookingId: string;
  test?: boolean;
}

export interface FlightExchangeReviewGetRequest {
  bookingId: string;
  exchangeId: string;
  test?: boolean;
  paymentMethodId?: string;
}

/**
 *
 */
export class FlightExchangesApi extends runtime.BaseAPI {
  /**
   * Owner-only supplier-test authentication of the exact accepted exchange and ordinary saved card. Start commits a one-shot attempt before creating a supplier Card/session. A spent unknown outcome cannot recreate resources. GET reads current durable progress without supplier IO. This never charges, confirms an exchange, or enables production. Uncertified scopes stay assisted.
   */
  async flightExchangeAuthenticationCreateRaw(
    requestParameters: FlightExchangeAuthenticationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeAuthenticationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeAuthenticationCreate().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeAuthenticationCreate().'
      );
    }

    if (requestParameters["flightExchangeAuthenticationRequest"] == null) {
      throw new runtime.RequiredError(
        "flightExchangeAuthenticationRequest",
        'Required parameter "flightExchangeAuthenticationRequest" was null or undefined when calling flightExchangeAuthenticationCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/authentication`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightExchangeAuthenticationRequestToJSON(
          requestParameters["flightExchangeAuthenticationRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeAuthenticationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Owner-only supplier-test authentication of the exact accepted exchange and ordinary saved card. Start commits a one-shot attempt before creating a supplier Card/session. A spent unknown outcome cannot recreate resources. GET reads current durable progress without supplier IO. This never charges, confirms an exchange, or enables production. Uncertified scopes stay assisted.
   */
  async flightExchangeAuthenticationCreate(
    requestParameters: FlightExchangeAuthenticationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeAuthenticationResponse> {
    const response = await this.flightExchangeAuthenticationCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Owner-only supplier-test authentication of the exact accepted exchange and ordinary saved card. Start commits a one-shot attempt before creating a supplier Card/session. A spent unknown outcome cannot recreate resources. GET reads current durable progress without supplier IO. This never charges, confirms an exchange, or enables production. Uncertified scopes stay assisted.
   */
  async flightExchangeAuthenticationGetRaw(
    requestParameters: FlightExchangeAuthenticationGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeAuthenticationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeAuthenticationGet().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeAuthenticationGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/authentication`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeAuthenticationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Owner-only supplier-test authentication of the exact accepted exchange and ordinary saved card. Start commits a one-shot attempt before creating a supplier Card/session. A spent unknown outcome cannot recreate resources. GET reads current durable progress without supplier IO. This never charges, confirms an exchange, or enables production. Uncertified scopes stay assisted.
   */
  async flightExchangeAuthenticationGet(
    requestParameters: FlightExchangeAuthenticationGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeAuthenticationResponse> {
    const response = await this.flightExchangeAuthenticationGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Explicitly refresh only the persisted native test session and independently verify its exact Card/resource/test identities. This is a native POST action, not a read-only supplier operation. No automatic retry, new session, browser-supplied status, charge or exchange confirmation.
   */
  async flightExchangeAuthenticationRefreshRaw(
    requestParameters: FlightExchangeAuthenticationRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeAuthenticationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeAuthenticationRefresh().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeAuthenticationRefresh().'
      );
    }

    if (
      requestParameters["flightExchangeAuthenticationRefreshRequest"] == null
    ) {
      throw new runtime.RequiredError(
        "flightExchangeAuthenticationRefreshRequest",
        'Required parameter "flightExchangeAuthenticationRefreshRequest" was null or undefined when calling flightExchangeAuthenticationRefresh().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/authentication/refresh`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightExchangeAuthenticationRefreshRequestToJSON(
          requestParameters["flightExchangeAuthenticationRefreshRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeAuthenticationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Explicitly refresh only the persisted native test session and independently verify its exact Card/resource/test identities. This is a native POST action, not a read-only supplier operation. No automatic retry, new session, browser-supplied status, charge or exchange confirmation.
   */
  async flightExchangeAuthenticationRefresh(
    requestParameters: FlightExchangeAuthenticationRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeAuthenticationResponse> {
    const response = await this.flightExchangeAuthenticationRefreshRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Owned supplier-test exchange execution. Explicit confirmation grants one durable native attempt. Repeated confirmation never replays. Recovery only retrieves the persisted change after uncertainty, even after quote expiry. A confirmed supplier change alone does not prove payment or replacement tickets. Production and unsupported scopes remain assisted. Responses are no-store.
   */
  async flightExchangeConfirmationCreateRaw(
    requestParameters: FlightExchangeConfirmationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeConfirmationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeConfirmationCreate().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeConfirmationCreate().'
      );
    }

    if (requestParameters["flightExchangeConfirmationRequest"] == null) {
      throw new runtime.RequiredError(
        "flightExchangeConfirmationRequest",
        'Required parameter "flightExchangeConfirmationRequest" was null or undefined when calling flightExchangeConfirmationCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/confirmation`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightExchangeConfirmationRequestToJSON(
          requestParameters["flightExchangeConfirmationRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeConfirmationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Owned supplier-test exchange execution. Explicit confirmation grants one durable native attempt. Repeated confirmation never replays. Recovery only retrieves the persisted change after uncertainty, even after quote expiry. A confirmed supplier change alone does not prove payment or replacement tickets. Production and unsupported scopes remain assisted. Responses are no-store.
   */
  async flightExchangeConfirmationCreate(
    requestParameters: FlightExchangeConfirmationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeConfirmationResponse> {
    const response = await this.flightExchangeConfirmationCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Owned supplier-test exchange execution. Explicit confirmation grants one durable native attempt. Repeated confirmation never replays. Recovery only retrieves the persisted change after uncertainty, even after quote expiry. A confirmed supplier change alone does not prove payment or replacement tickets. Production and unsupported scopes remain assisted. Responses are no-store.
   */
  async flightExchangeConfirmationGetRaw(
    requestParameters: FlightExchangeConfirmationGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeConfirmationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeConfirmationGet().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeConfirmationGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/confirmation`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeConfirmationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Owned supplier-test exchange execution. Explicit confirmation grants one durable native attempt. Repeated confirmation never replays. Recovery only retrieves the persisted change after uncertainty, even after quote expiry. A confirmed supplier change alone does not prove payment or replacement tickets. Production and unsupported scopes remain assisted. Responses are no-store.
   */
  async flightExchangeConfirmationGet(
    requestParameters: FlightExchangeConfirmationGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeConfirmationResponse> {
    const response = await this.flightExchangeConfirmationGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Owned supplier-test exchange execution. Explicit confirmation grants one durable native attempt. Repeated confirmation never replays. Recovery only retrieves the persisted change after uncertainty, even after quote expiry. A confirmed supplier change alone does not prove payment or replacement tickets. Production and unsupported scopes remain assisted. Responses are no-store.
   */
  async flightExchangeConfirmationRecoverRaw(
    requestParameters: FlightExchangeConfirmationRecoverRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeConfirmationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeConfirmationRecover().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeConfirmationRecover().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/confirmation/recover`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeConfirmationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Owned supplier-test exchange execution. Explicit confirmation grants one durable native attempt. Repeated confirmation never replays. Recovery only retrieves the persisted change after uncertainty, even after quote expiry. A confirmed supplier change alone does not prove payment or replacement tickets. Production and unsupported scopes remain assisted. Responses are no-store.
   */
  async flightExchangeConfirmationRecover(
    requestParameters: FlightExchangeConfirmationRecoverRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeConfirmationResponse> {
    const response = await this.flightExchangeConfirmationRecoverRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Review or acknowledge exact exchange quote terms and an ordinary owned saved-card revision. This does not authenticate a payment, authorize a charge, or confirm the exchange. Supplier-test only; no supplier mutations are performed.
   */
  async flightExchangeConsentCreateRaw(
    requestParameters: FlightExchangeConsentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeReviewResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeConsentCreate().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeConsentCreate().'
      );
    }

    if (requestParameters["flightExchangeConsentRequest"] == null) {
      throw new runtime.RequiredError(
        "flightExchangeConsentRequest",
        'Required parameter "flightExchangeConsentRequest" was null or undefined when calling flightExchangeConsentCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/consent`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightExchangeConsentRequestToJSON(
          requestParameters["flightExchangeConsentRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeReviewResponseFromJSON(jsonValue)
    );
  }

  /**
   * Review or acknowledge exact exchange quote terms and an ordinary owned saved-card revision. This does not authenticate a payment, authorize a charge, or confirm the exchange. Supplier-test only; no supplier mutations are performed.
   */
  async flightExchangeConsentCreate(
    requestParameters: FlightExchangeConsentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeReviewResponse> {
    const response = await this.flightExchangeConsentCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Prepare or retrieve an owner-scoped supplier-test exchange preview. No payment, confirmation or ticket replacement is performed. Uncertain preparation is recovered through the same identities; retrieval never creates supplier resources.
   */
  async flightExchangePreparationCreateRaw(
    requestParameters: FlightExchangePreparationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangePreparationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangePreparationCreate().'
      );
    }

    if (requestParameters["flightExchangePreparationRequest"] == null) {
      throw new runtime.RequiredError(
        "flightExchangePreparationRequest",
        'Required parameter "flightExchangePreparationRequest" was null or undefined when calling flightExchangePreparationCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightExchangePreparationRequestToJSON(
          requestParameters["flightExchangePreparationRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangePreparationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Prepare or retrieve an owner-scoped supplier-test exchange preview. No payment, confirmation or ticket replacement is performed. Uncertain preparation is recovered through the same identities; retrieval never creates supplier resources.
   */
  async flightExchangePreparationCreate(
    requestParameters: FlightExchangePreparationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangePreparationResponse> {
    const response = await this.flightExchangePreparationCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Prepare or retrieve an owner-scoped supplier-test exchange preview. No payment, confirmation or ticket replacement is performed. Uncertain preparation is recovered through the same identities; retrieval never creates supplier resources.
   */
  async flightExchangePreparationGetRaw(
    requestParameters: FlightExchangePreparationGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangePreparationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangePreparationGet().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangePreparationGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangePreparationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Prepare or retrieve an owner-scoped supplier-test exchange preview. No payment, confirmation or ticket replacement is performed. Uncertain preparation is recovered through the same identities; retrieval never creates supplier resources.
   */
  async flightExchangePreparationGet(
    requestParameters: FlightExchangePreparationGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangePreparationResponse> {
    const response = await this.flightExchangePreparationGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Prepare or retrieve an owner-scoped supplier-test exchange preview. No payment, confirmation or ticket replacement is performed. Uncertain preparation is recovered through the same identities; retrieval never creates supplier resources.
   */
  async flightExchangePreparationLatestGetRaw(
    requestParameters: FlightExchangePreparationLatestGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangePreparationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangePreparationLatestGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/latest`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangePreparationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Prepare or retrieve an owner-scoped supplier-test exchange preview. No payment, confirmation or ticket replacement is performed. Uncertain preparation is recovered through the same identities; retrieval never creates supplier resources.
   */
  async flightExchangePreparationLatestGet(
    requestParameters: FlightExchangePreparationLatestGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangePreparationResponse> {
    const response = await this.flightExchangePreparationLatestGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Review or acknowledge exact exchange quote terms and an ordinary owned saved-card revision. This does not authenticate a payment, authorize a charge, or confirm the exchange. Supplier-test only; no supplier mutations are performed.
   */
  async flightExchangeReviewGetRaw(
    requestParameters: FlightExchangeReviewGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightExchangeReviewResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightExchangeReviewGet().'
      );
    }

    if (requestParameters["exchangeId"] == null) {
      throw new runtime.RequiredError(
        "exchangeId",
        'Required parameter "exchangeId" was null or undefined when calling flightExchangeReviewGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    if (requestParameters["paymentMethodId"] != null) {
      queryParameters["payment_method_id"] =
        requestParameters["paymentMethodId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/exchange-preparations/{exchange_id}/review`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"exchange_id"}}`,
      encodeURIComponent(String(requestParameters["exchangeId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightExchangeReviewResponseFromJSON(jsonValue)
    );
  }

  /**
   * Review or acknowledge exact exchange quote terms and an ordinary owned saved-card revision. This does not authenticate a payment, authorize a charge, or confirm the exchange. Supplier-test only; no supplier mutations are performed.
   */
  async flightExchangeReviewGet(
    requestParameters: FlightExchangeReviewGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightExchangeReviewResponse> {
    const response = await this.flightExchangeReviewGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
